import { CANDIDATE } from "../Action";
 const headerData=[
    {
      name: "ID",
      direction: "desc",
      defaultDirection: "desc",
      sort: true,
      active: false,
      width: "6%",
      key: "order_no",
    },
    {
      name: "Name",
      direction: "asc",
      defaultDirection: "asc",
      sort: true,
      active: false,
      width: "16%",
      key: "personal_details.candidate_name.keyword",
    },
    {
      name: "Title",
      direction: "asc",
      defaultDirection: "asc",
      sort: true,
      active: false,
      width: "30%",
      key: "personal_details.title.keyword",
    },
    {
      name: "Status",
      direction: "asc",
      defaultDirection: "asc",
      sort: false,
      width: "10%",
    },
    {
      name: "Score",
      direction: "asc",
      defaultDirection: "asc",
      sort: false,
      width: "14%",
    },
    {
      name: "Last Activity",
      direction: "desc",
      defaultDirection: "desc",
      sort: true,
      active: true,
      width: "15%",
      key: "updated_at",
    },
    { width: "5%" },
  ];
const intialState = {
  candidateViewData: {},
  candidateBuildPipeline: {
    data: [],
    status: "",
  },
  addToJobPool: {
    data: [],
  },
   candidateFilter: {
    filter: {},
    search: "",
    pagination: 1,
    headerData: headerData,
    columnkey: "updated_at",
    direction: "desc",
    status: true,
  },
};
const CandidateReducer = (state = intialState, action) => {
  switch (action.type) {
    case CANDIDATE.candidateView:
      return { ...state, candidateViewData: action.data };
    case CANDIDATE.candidateBuildPipeline:
      return {
        ...state,
        candidateBuildPipeline: {
          ...state.candidateBuildPipeline,
          data: action.data.data,
          status: action.data.status,
        },
      };
    case CANDIDATE.addToJobPool:
      return {
        ...state,
        addToJobPool: {
          ...state.addToJobPool,
          data: action.data.data,
        },
      };
      case "SET_CANDIDATE_FILTER":
         return { ...state, candidateFilter: action.payload };
  
    default:
      return state;
  }
};
export default CandidateReducer;
